import styled from '@emotion/styled'

export const StyleAccordionWrapper = styled.div<any>`
  display: flex;
  flex-direction: column;
  row-gap: 20px;
`

export const StyleAccordionItemWrapper = styled.div<any>`
  background: ${(props: any) => props.theme.colors.white};
  border-radius: 8px;
  padding: 10px 15px;
  box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.1);
`
export const StyleAccordionItemTitleWrapper = styled.div<any>`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`
export const StyleAccordionIconWrapper = styled.div<any>`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
`
export const StyleAccordionItemContentWrapper = styled.div<any>`
  margin-top: 20px;
  transition: all 0.5s ease-in-out;
  display: flex;
  align-items: center;
  justify-content: center;
`
export const StyleAccoridionItemTitle = styled.h3`
  font-size: 18px;
  color: ${(props: any) => props.theme.colors.primary};
  font-weight: 400;
`
export const StyleAccordionItemDescription = styled.p`
  font-size: 14px;
  font-weight: 300;
  color: ${(props: any) => props.theme.colors.text100};
  line-height: 20px;
`
